import React from 'react'
import CentreRoutes from './centre-routes'
import { CentreShell, RawCentrePage } from './centre-shell'

export { RawCentrePage }

const Centre = props => (
  <CentreShell {...props}>
    {({ centre, firstPage }) => <CentreRoutes {...{ centre, firstPage }} />}
  </CentreShell>
)

export default Centre
